import React from "react";
import {
  Icon,
  IconButton,
  Tooltip,
  withStyles,
} from "@material-ui/core";
import styles from "./styles";

const ToolbarIcon = (props) => {
  const { classes, title, iconClass, onClick } = props;
  return (
    <Tooltip title={title} placement="bottom">
      <IconButton
        onClick={onClick}
        className={classes.toolbarIcon}
      >
        <Icon className={iconClass} style={{ fontSize: 16 }} />
      </IconButton>
    </Tooltip>
  )
};

export default withStyles(styles, { withTheme: true })(ToolbarIcon);